"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requiredFieldValidation = void 0;
// eslint-disable-next-line import/prefer-default-export
function requiredFieldValidation(conf, form) {
    const error = {
        global: [],
        field: [],
    };
    conf.forEach((opt) => {
        if (opt) {
            let doList;
            if (Array.isArray(opt)) {
                doList = opt;
            }
            else {
                doList = [opt];
            }
            doList.forEach((del) => {
                if (!del) {
                    return;
                }
                let foList;
                if (Array.isArray(del)) {
                    foList = del;
                }
                else {
                    foList = [del];
                }
                foList.forEach((fel) => {
                    if (fel.required) {
                        if (!form ||
                            form[fel.key] === '' ||
                            form[fel.key] === undefined ||
                            form[fel.key] === null) {
                            error.field?.push({
                                key: fel.key,
                                message: 'Required fields are not allowed to be empty',
                            });
                        }
                    }
                });
            });
        }
    });
    return error;
}
exports.requiredFieldValidation = requiredFieldValidation;
